import * as go from 'gojs';
import { calculateAttentionNodeLocation, findAttachedAttentionNodes } from '../../attention-node/utils/attention-utils';

export class CustomNodeGroupLayout extends go.TreeLayout {
  doLayout(coll: go.Diagram | go.Group | go.Iterable<go.Part>) {
    super.doLayout(coll);

    if (!(coll instanceof go.Group) || !this.diagram) {
      return;
    }

    const attachedAttentionNodes = findAttachedAttentionNodes(this.diagram.nodes);

    coll.memberParts
      .filter((node) => !!node.key && node.key in attachedAttentionNodes)
      .each((node) => {
        const attentionNode = attachedAttentionNodes[node.key!];
        const position = calculateAttentionNodeLocation(node);
        attentionNode.move(position, true);
      });
  }
}
